export const FilterIcon = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2028_26680)">
      <rect width="8" height="8" rx="4" fill="#1976D2" />
    </g>
    <defs>
      <clipPath id="clip0_2028_26680">
        <rect width="8" height="8" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
